<template>
  <a-cascader
    v-model:value="selectSerial"
    :options="options"
    @change="handleSerialChange"
    placeholder="选择设备类型"
    style="width: 100%"
    :disabled="props.disabled"
  />
</template>

<script>
import { defineComponent, ref, watch } from "vue";

export default defineComponent({
  props: {
    disabled: Boolean,
    echoData: Array,
  },
  setup(props, content) {
    const options = [
      {
        value: "天鸽",
        label: "天鸽",
        children: [
          {
            value: "300",
            label: "300",
          },
          {
            value: "300S",
            label: "300S",
          },
        ],
      },
      {
        value: "天鹅",
        label: "天鹅",
        children: [
          {
            value: "600",
            label: "600",
          },
          {
            value: "600P",
            label: "600P",
          },
        ],
      },
      // {
      //   value: "筛查箱",
      //   label: "筛查箱",
      //   children: [
      //     {
      //       value: "310",
      //       label: "310",
      //     },
      //     {
      //       value: "310S",
      //       label: "310S",
      //     },
      //   ],
      // },
    ];
    const selectSerial = ref([]);

    const handleSerialChange = (e) => {
      if (selectSerial.value.length === 2) {
        const [machine, type] = e;
        content.emit("handleSerialChange", `${machine}${type}`);
      } else {
        content.emit("handleSerialChange", null);
      }
    };

    watch(
      () => props.echoData,
      (val) => {
        if (val && val.length === 2) {
          selectSerial.value.length = 0;
          selectSerial.value.push(...val);
        } else {
          selectSerial.value.length = 0;
        }
      },
      {
        deep: true,
        immediate: true,
      }
    );

    return {
      options,
      selectSerial,
      handleSerialChange,
      props,
    };
  },
});
</script>

<style lang="less" scoped>
</style>
